"use strict";
/**
 * 前端站点地区检测
 *
 * 地区信息由 Fego 系统通过 window._params.siteId 注入，
 * 经 @ark/utils 的 SITE_ID_LOCATION_MAP 映射为展业地区。
 * 取不到（缺失 / 未知 siteId）时直接抛错，不做 URL 猜测或默认兜底，
 * 以便及时暴露宿主未正确注入地区信息的问题。
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SITE_LOCATION_HEADER = void 0;
exports.getSiteLocation = getSiteLocation;
exports._resetForTesting = _resetForTesting;
const utils_1 = require("@ark/utils");
/** 站点地区请求头名称 */
exports.SITE_LOCATION_HEADER = 'x-activity-site-location';
let cachedLocation;
/**
 * 获取当前站点地区。
 *
 * 从 Fego 注入的 siteId 解析；解析成功后缓存，多次调用不重复计算。
 *
 * @returns BusinessLocation 枚举值
 * @throws 当 window._params.siteId 缺失或无法映射为展业地区时抛错
 */
function getSiteLocation() {
    if (cachedLocation)
        return cachedLocation;
    const location = (0, utils_1.resolveFrontendLocation)();
    if (!location) {
        throw new Error('[web-api] 无法从 window._params.siteId 获取展业地区，请确认宿主已正确注入 siteId');
    }
    cachedLocation = location;
    return cachedLocation;
}
/**
 * 重置缓存（仅用于测试）
 */
function _resetForTesting() {
    cachedLocation = undefined;
}
